import dom from "../../../dist/jsx-render/dom";
import { app } from "../../Frame/App";
import { TextComponent } from "../../Components/TextComponent";
import { DateControl } from "../../BindingControls/DateControl";
import { Controller as BindingController } from "../../BindingControls/Controller";
import { RadioButtonComponent } from "../../Components/RadioButtonComponent";
import { UserDropdownComponent } from "../../Components/Dropdowns/UserDropdownComponent";
import { DropDownComponent, OnDropDownChange, DropDownComponentProps } from "../DropDownComponent";
import { AmpelComponent } from "../AmpelComponent";
import { TreeItem } from "../../Areas/Admin/Reports/Models/TreeItem";
import { TemplateConditionContext } from "./ConditionContext/TemplateConditionContext";
import { FieldAttributesDataFromSubmeasures } from "../../Areas/Admin/Shared/Models/AttributesDataFromSubmeasures";
import { FieldModel } from "../Dropdowns/FieldDropdownComponent";
import { ITemplateFieldListItem } from "../../Model/IListItem";
import { ConditionComponent } from "./ConditionComponent";
import { TemplateFieldTypes } from "../../Areas/Admin/Shared/Models/TemplateFieldTypes";
import { DateFieldComponent } from "../DateFieldComponent";

export class ValueFieldHelper {
    createTextField = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);
        valueContainer.appendChild(
            <TextComponent model={props.model}
                field="value"
                name={Resources.Common.value}
                showLabel={true}
                additionalCssClasses="valueField" />
        );
    }

    createTextArea = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);
        valueContainer.appendChild(<TextComponent model={props.model}
            field="value"
            name={Resources.Common.value}
            textarea={true}
            showLabel={true}
            additionalCssClasses="valueField" />
        );
    }

    createRadioButtons = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);
        valueContainer.appendChild(<RadioButtonComponent model={props.model}
            field="value"
            options={[
                { description: Resources.Common.yes, value: 1 },
                { description: Resources.Common.no, value: 0 }
            ]}
            inline={true}
            name={Resources.Common.value} />
        );
    }

    createDecimalControl = (element: HTMLElement, props: any, field: TreeItem) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        valueContainer.appendChild(
            <TextComponent model={props.model}
                field="value"
                name={Resources.Common.value}
                showLabel={true}
                additionalCssClasses="valueField"
                restrictTo="decimal"
                decimalPlaces={field.decimals}
                decimalSeparator={props.decimalChar}
            />
        );

        // TODO Get separator and decimal places from field.
        //decimalSeparator = { 0}
        //decimalPlaces = { 2}
    }

    createIntControl = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        valueContainer.appendChild(
            <TextComponent model={props.model}
                field="value"
                name={Resources.Common.value}
                showLabel={true}
                additionalCssClasses="valueField"
                restrictTo="integer"
            />
        );
    }

    createDateTimePicker = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);
        this.createTextField(element, props);

        let inputElement = element.querySelector(".value input") as HTMLInputElement;
        let datePickerFrom = new DateControl(inputElement, new BindingController(null, true), "dateValue");
        datePickerFrom.setModel(props.model);
    }

    createDateTimeControl = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);
        
        valueContainer.appendChild(<DateFieldComponent
            model={props.model}
            template={props.context.template}
            useField={true} />
        );
    }

    createUserControl = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        valueContainer.appendChild(<UserDropdownComponent
            field="value"
            model={props.model}
            name={Resources.Common.value}
            friendlyValueField="friendlyValue" />);
    }

    createTemplateListControl = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        let onChange: OnDropDownChange = (control: DropDownComponent) => {
            props.model.value = (control as DropDownComponent).getValue();
            props.model.friendlyValue = (control as DropDownComponent).getSelectedItem().text;
        }

        let dropdownProps: DropDownComponentProps = {
            url: app.resolveUrl("~/api/dynamic/getAvailableTemplates"),
            displayProperty: "text",
            valueProperty: "id",
            id: app.createRadomizedLetters(10) + "_templates",
            name: Resources.Common.value,
            onChange: onChange
        }
        let dropdown = new DropDownComponent(dropdownProps);

        valueContainer.appendChild(dropdown.render());
        if (props.model.value) {
            dropdown.setValue(props.model.value);
        }
    }

    createCategoryControl = (element: HTMLElement, categoryId: number, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        let onCategoryChange: OnDropDownChange = (control: DropDownComponent) => {
            props.model.value = (control as DropDownComponent).getValue();
            props.model.friendlyValue = (control as DropDownComponent).getSelectedItem().text;
        }

        let dropdownProps = {
            id: app.createRadomizedLetters(10),
            url: app.resolveUrl(`~/api/dynamic/getCategoryContentForFilter/${categoryId}`),
            displayProperty: "text",
            valueProperty: "id",
            addEmptyItem: false,
            name: Resources.Common.value,
            onChange: onCategoryChange,
            selectedValue: props.model.value
        }
        valueContainer.appendChild(new DropDownComponent(dropdownProps).render());
    }

    createAmpelControl = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        valueContainer.appendChild(<AmpelComponent
            fieldName="value"
            model={props.model}
            name={Resources.Common.value}
            friendlyValueField="friendlyValue"
            useGrey={true}
        />);
    }

    clearValueArea = (element: HTMLElement) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);
    }

    createTemplateStatusControl = (element: HTMLElement, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        let onChange: OnDropDownChange = (control: DropDownComponent) => {
            props.model.value = (control as DropDownComponent).getValue();
            props.model.friendlyValue = (control as DropDownComponent).getSelectedItem().text;
        }

        let dropdownProps: DropDownComponentProps = {
            url: app.resolveUrl("~/api/dynamic/getAvailableTemplateStatus"),
            displayProperty: "text",
            valueProperty: "id",
            id: app.createRadomizedLetters(10) + "_templateStatus",
            name: Resources.Common.value,
            onChange: onChange
        }
        let dropdown = new DropDownComponent(dropdownProps);

        valueContainer.appendChild(dropdown.render());
        if (props.model.value) {
            dropdown.setValue(props.model.value);
        }
    }

    createParentStatusControl = (element: HTMLElement, statusFromParentUrl: string, props: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        let onChange: OnDropDownChange = (control: DropDownComponent) => {
            props.model.value = (control as DropDownComponent).getValue();
            props.model.friendlyValue = (control as DropDownComponent).getSelectedItem().text;
        }

        let dropdownProps: DropDownComponentProps = {
            url: app.resolveUrl(statusFromParentUrl),
            displayProperty: "text",
            valueProperty: "id",
            id: app.createRadomizedLetters(10) + "_ParentStatus",
            name: Resources.Common.value,
            onChange: onChange
        }
        let dropdown = new DropDownComponent(dropdownProps);

        valueContainer.appendChild(dropdown.render());
        if (props.model.value) {
            dropdown.setValue(props.model.value);
        }
    }

    createDataFromSubmeasuresControl = (conditionComponent: ConditionComponent, element: HTMLElement, props: any, selectedField: any) => {
        let valueContainer = element.querySelector(".value") as HTMLDivElement;
        app.destroyDomChildren(valueContainer);

        let fieldAttributes: FieldAttributesDataFromSubmeasures;
        let childFieldId: number;

        if (props.context instanceof TemplateConditionContext) {
            // We are in the page TemplateEdit - we can get the attributes of the selected DataFromSubmeasures field directly from the context.
            // We need the attributes from the context, otherwise any changes the user made while editing this template, that have not yet been saved, will not be available here.
            let template = (props.context as TemplateConditionContext).getTemplate();
            if (template) {
                // selectedField is of type FieldModel
                let typedSelectedField = selectedField as FieldModel;

                let field = template.fields.items.find(f => f.guid == typedSelectedField.value);
                try {
                    fieldAttributes = JSON.parse(field.attributesJson);
                    childFieldId = fieldAttributes.templateFieldId;
                } catch (err) {
                    console.log(err);
                    return;
                }

                // Get selected field from child template
                // TODO Evtl unter das if schieben...
                $.ajax({
                    url: app.resolveUrl(`~/api/admin/getField/${childFieldId}`),
                    method: "GET",
                    success: (response) => {
                        var field = response as ITemplateFieldListItem;
                        if (field) {

                            let operators = (props.context as TemplateConditionContext).getOperatorsForFieldType(field.templateFieldType);
                            conditionComponent.createOperatorSelectControl(operators);

                            switch (field.templateFieldType) {
                                case TemplateFieldTypes.JaNein:
                                case TemplateFieldTypes.BlockFinished:
                                    this.createRadioButtons(element, props);
                                    break;
                                case TemplateFieldTypes.Zahl:
                                    let fieldModel = field.attributesJson ? JSON.parse(field.attributesJson) : "";
                                    // set the model decimals if available
                                    if (fieldModel != "" && fieldModel.Decimals != undefined && fieldModel.Decimals != "" && typeof fieldModel.Decimals === 'number') {
                                        fieldModel.decimals = fieldModel.Decimals;
                                    }
                                    this.createDecimalControl(element, props, fieldModel);
                                    break;
                                case TemplateFieldTypes.Datum:
                                case TemplateFieldTypes.ParentContentDate:
                                case TemplateFieldTypes.BlockDate:
                                    if (props.showOnlyDatePicker) {
                                        // For list views.
                                        this.createDateTimePicker(element, props);
                                    }
                                    else {
                                        this.createDateTimeControl(element, props);
                                    }
                                    break;
                            }
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });

            }

        } else {
            // GridViewConditionContext - We are at any other page where conditions are used and we have to get the field attributes from the server.
            // TODO Hier kommt schon das richtige Control raus - prüfen, warum
        }


    }

    clearCategoryValue = (props: any) => {
        if (props.model["categoryId"] && props.model["categoryId"] != "0") {
            props.model["categoryId"] = "0";
        }
    }
}